<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="modal-lg">
    <div class="modal-header">
        <div class="modal-wizard-label">
            <div class="modal-wizard-title">
                Datos de Facturación
            </div>
            <div class="modal-wizard-desc">
                Complete los campos requeridos para generar su factura por esta compra.
            </div>
        </div>
    </div>
    <form [formGroup]="certificadoForm" (ngSubmit)="onSubmit()" class="formularioCertificado">
        <div class="modal-body " tabindex="-1" ngbAutofocus>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="rut">Rut <span class="text-danger">*</span></label>
                        <div class="input-group">
                            <input type="text" id="rut" formControlName="rut" class="form-control" placeholder="Ingrese el Rut"
                                    (blur)="buscaCliente($event.target.value)" required/>
                            <div class="input-group-append" *ngIf="buscandoDatos">
                                <span class="input-group-text bg-warning">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </span>
                            </div>
                            <div class="input-group-append" *ngIf="!existe && !buscandoDatos && certificadoForm.get('rut').valid">
                                <span class="input-group-text bg-success text-white">
                                <i class="fa fa-check"></i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="certificadoForm.get('rut').touched && certificadoForm.get('rut').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('rut').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="correo">Correo<span class="text-danger">*</span></label>
                        <input type="email" id="correo" formControlName="correo" class="form-control" placeholder="Ingrese el correo" required />
                        <div *ngIf="certificadoForm.get('correo').touched && certificadoForm.get('correo').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('correo').errors?.required">Campo requerido</div>
                            <div *ngIf="certificadoForm.get('correo').errors?.email">Correo inválido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="nombreEmpresa">Razón social <span class="text-danger">*</span></label>
                        <input type="text" id="nombreEmpresa" formControlName="nombreEmpresa" class="form-control" placeholder="Ingrese la Razón social" required />
                        <div *ngIf="certificadoForm.get('nombreEmpresa').touched && certificadoForm.get('nombreEmpresa').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('nombreEmpresa').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="comuna">Comuna <span class="text-danger">*</span></label>
                        <ng-select
                            id="comuna"
                            formControlName="comuna"
                            [items]="comunas"
                            placeholder="Seleccione una comuna"
                            [clearable]="false"
                            [ngClass]="{'is-invalid': certificadoForm.get('comuna')!.invalid && (certificadoForm.touched || certificadoForm.dirty)}">
                        </ng-select>
                        <div *ngIf="certificadoForm.get('comuna').touched && certificadoForm.get('comuna').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('comuna').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="direccion">Dirección <span class="text-danger">*</span></label>
                        <input type="text" id="direccion" formControlName="direccion" class="form-control" placeholder="Ingrese la dirección" required />
                        <div *ngIf="certificadoForm.get('direccion').touched && certificadoForm.get('direccion').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('direccion').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="giroEmpresa">Giro<span class="text-danger">*</span></label>
                        <input type="text" id="giroEmpresa" formControlName="giroEmpresa" class="form-control" placeholder="Ingrese el giro de la empresa" required />
                        <div *ngIf="certificadoForm.get('giroEmpresa').touched && certificadoForm.get('giroEmpresa').invalid" class="text-danger">
                            <div *ngIf="certificadoForm.get('giroEmpresa').errors?.required">Campo requerido</div>
                        </div>
                    </div>
                </div>
               <div class="col-md-3">
                    <div class="form-group">
                        <label for="telefonoContacto">Teléfono</label>
                        <div class="input-group input-group-telefono">
                            <div class="input-group-append">
                                <span class="input-group-text">+56</span>
                            </div>
                            <input
                                type="number"
                                id="telefonoContacto"
                                formControlName="telefonoContacto"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                maxlength="10"
                                min="1"
                                placeholder="962212767"
                                class="form-control telefono"
                            />
                        </div>
                        <span class="form-text text-muted text-telefono">Cod. País + Teléfono</span>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="duracion">Duración certificado <span class="text-danger">*</span></label>
                        <ng-container *ngIf="mode !== 'generar'; else txtPeriodo">
                            <ng-select
                              [items]="periodos"
                              bindLabel="label"
                              bindValue="value"
                              formControlName="duracion"
                              placeholder="Selecciona la duración del certificado"
                              [clearable]="false"
                              [ngClass]="{'is-invalid': certificadoForm.get('duracion')!.invalid && (certificadoForm.touched || certificadoForm.dirty)}">
                            </ng-select>
                        </ng-container>
                        <ng-template #txtPeriodo>
                        <input id="duracion" type="text" class="form-control" formControlName="duracion" [disabled]="mode === 'generar'"  />
                        </ng-template>
                    </div>
                </div>
                <div class="col-md-6 mt-10">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="chkGarantia" formControlName="garantia"  [disabled]="mode === 'generar'" />
                        <label class="form-check-label" for="chkGarantia">
                            Incluir Garantía de Recuperación
                        </label>
                        <i class="fa fa-question-circle ml-1" [ngbTooltip]="tooltipContent" container="body"></i>
                    </div>
                </div>
                <div class="table-responsive col-md-12" *ngIf="mode !== 'generar'">
                    <table *ngIf="!loading" class="table table-sm  table-bordered">
                        <thead class="thead-light">
                            <tr>
                                <th>Duración</th>
                                <th class="text-center">Precio Base</th>
                                <th class="text-center">Garantía de Recuperación</th>
                                <th class="text-center">Total sin Garantía + IVA</th>
                                <th class="text-center">Total con Garantía + IVA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let periodo of tablaPrecios" 
                                    [ngClass]="{'table-primary': certificadoForm.get('duracion')?.value === periodo.duracion}">
                                <td>
                                    {{ periodo.duracion }} Año{{ periodo.duracion > 1 ? 's' : '' }}
                                    <span *ngIf="certificadoForm.get('duracion')?.value === periodo.duracion" 
                                        class="badge badge-success ml-2">Seleccionado</span>
                                </td>
                                <td class="text-center">$ {{ periodo.precioCertificado  | number:'1.0-0':'es-CL' }}</td>
                                <td class="text-center">$ {{ periodo.precioGarantia  | number:'1.0-0':'es-CL' }}</td>
                                <td class="text-center">
                                    <strong>$ {{ periodo.precioCertificado  * 1.19 | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                                <td class="text-center">
                                    <strong>$ {{ (periodo.precioCertificado  + periodo.precioGarantia) * 1.19 | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="certificadoForm.get('duracion')?.value && periodoSel">
                            <tr class="table-secondary">
                                <td colspan="4" class="text-right"><strong>Total a pagar:</strong></td>
                                <td class="text-center">
                                    <strong class="text-primary">$ {{ total | number:'1.0-0':'es-CL' }}</strong>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-footer d-flex align-items-center p-3">
            <div class="text-warning mr-auto col-md-8">
                <strong>Recuerde que estos datos son de facturación. Una vez realizado el pago, le llegarán instrucciones a su correo para generar su certificado digital.</strong>
            </div>
            <div>
                <button class="btn btn-primary mr-2"
                    type="submit"
                    [disabled]="certificadoForm.invalid">
                    {{ mode==='renovar' ? 'Renovar' : 'Comprar' }}
                </button>
                <button type="button" class="btn btn-secondary" (click)="active.dismiss()">Cancelar</button>
            </div>
        </div>
    </form>
</div>

<ng-template #tooltipContent>
	<div class="tooltip-content">
		<p class="mb-0">
			Garantía de Recuperación: 
			Puedes añadir la garantía de recuperación para descargar tu certificado las veces que necesites desde tu panel, sin un costo adicional.
		</p>
	</div>
</ng-template>
  
<ng-template #tooltipContent>
	<img src="assets/media/users/carnet.jpg" alt="Ejemplo" style="width: 150px;" />
</ng-template>
